import { useContext } from 'react'

// context
import { AppContext } from '../../App'

// icons
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg'

// styles
import styles from './header.module.scss'

const Header = (): JSX.Element => {
	const appContext = useContext(AppContext)

	return (
		<header className={styles.header}>
			<div className={styles.main}>
				<p className={styles.logo}>TGL</p>
			</div>
			{appContext?.loggedIn && (
				<button
					type="button"
					className={styles.button}
					onClick={() => {
						appContext?.setLoggedIn(false)
					}}
				>
					<LogoutIcon />
					Logout
				</button>
			)}
		</header>
	)
}

export default Header
